(function($) {
  Drupal.behaviors.renutriv_section = {
    attach: function(context, settings) {
      $('body').addClass('brand-renutriv');
    }
  };
})(jQuery);
